<template>
  <b-alert
    v-if="!isVerify"
    variant="danger"
    dismissible
    fade
    :show="!isHide"
    @dismissed="isHide = true"
  >
    <div class="alert-body text-center">
      {{ $t("general.emailNotVerify") }}
      <b-link
        v-if="!loading"
        class="link-underline text-danger"
        @click="resendVerify"
      >
        {{ $t("button.verifyNow") }}
      </b-link>
      <b-spinner
        v-else
        small
      />
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BLink, BSpinner } from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Toast from '@/libs/toast'
import useJwt from '@/auth/jwt/useJwt'

const RegisterRepository = Repository.get('register')

export default {
  components: {
    BAlert,
    BLink,
    BSpinner,
  },
  data() {
    return {
      loading: false,
      isHide: false,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile?.email || this.$store.state.profile?.phone
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName))
    },
    isVerify() {
      if (this.$store.state.profile.isVerify) {
        return this.$store.state.profile.isVerify
      }

      return this.userData.isVerify
    },
  },
  methods: {
    resendVerify() {
      this.loading = true

      RegisterRepository.resend({ email: this.userData.email })
        .then(response => {
          const data = response?.data?.data
          if (data.isVerify) {
            localStorage.setItem(useJwt.jwtConfig.storageUserDataKeyName, JSON.stringify(data))
            this.$store.commit('profile/UPDATE_PROFILE', data)
            this.isHide = true
          } else {
            Toast.fire({
              icon: 'success',
              title: this.$t('general.verifyLinkSent'),
            })
          }
        })
        .catch(error => {})
        .then(() => {
          this.loading = false
        })
    },
  },
}
</script>
